import { makeStyles } from "@material-ui/core";
import palette from "theme/palette";

export default makeStyles((theme) => ({
  root: {
    paddingTop: 40,
    position: "relative",
  },
  cardHeading: {
    fontWeight: 400,
    fontSize: 16,
    letterSpacing: "-0.02em",
    color: "#404041",
    paddingBottom: 20,
  },
  sectionHeading: {
    fontWeight: 400,
    fontSize: 14,
    color: "#404041",
    padding: "20px 0",
  },
  accordGreen: {
    background: "#EAF6ED",
    borderRadius: 2,
    borderLeft: "3px solid #24A148",
    marginBottom: 15,
    "& p": {
      fontSize: 12,
      color: "#404041",
      "& svg": {
        color: "#24A148",
        verticalAlign: "middle",
        marginRight: 5,
      },
    },
  },
  accordRed: {
    background: "#FBE8E9",
    borderRadius: 2,
    borderLeft: "3px solid #E01F29",
    marginBottom: 15,
    "& p": {
      fontSize: 12,
      color: "#404041",
      "& svg": {
        color: "#E01F29",
        verticalAlign: "middle",
        marginRight: 5,
      },
    },
  },
  accordYellow: {
    background: "#FDF8E6",
    borderRadius: 2,
    borderLeft: "3px solid #F0BF0F",
    marginBottom: 15,
    "& p": {
      fontSize: 12,
      color: "#404041",
      "& svg": {
        color: "#F0BF0F",
        verticalAlign: "middle",
        marginRight: 5,
      },
    },
  },
  accordGrey: {
    background: "#F6F7F7",
    borderRadius: 2,
    borderLeft: "3px solid #404041",
    marginBottom: 15,
    "& p": {
      fontSize: 12,
      color: "#404041",
      "& svg": {
        color: "#404041",
        verticalAlign: "middle",
        marginRight: 5,
      },
    },
  },
  dualAccord: {
    color: "#E01F29 !important",
  },
  rightText: {
    float: "right",
    color: "#333333",
    cursor: "pointer",
    "& svg": {
      verticalAlign: "bottom",
      color: "#333333",
    },
  },
  backBtn: {
    float: "right",
    cursor: "pointer",
    position: "absolute",
    top: "-40px",
    right: 0,
    "& svg": {
      verticalAlign: "middle",
    },
    "& span": {
      verticalAlign: "middle",
    },
  },
  pageHeading: {
    fontSize: 20,
    color: "#333333",
  },
  description: {
    background: "#FCFCFC",
    border: "1px solid #E6E7E8",
    padding: 10,
    fontSize: 12,
  },
  heading: {
    fontSize: 14,
    color: "#929497",
    marginBottom: 5,
  },
  value: {
    fontSize: 14,
    color: "#333333",
    fontWeight: 500,
  },
  ongoingBtn: {
    background: "#58DA7E",
    color: "#ffffff",
    borderRadius: 0,
    textTransform: "capitalize",
    padding: "2px 8px",
    cursor: "auto",
    "& svg": {
      verticalAlign: "middle",
      fontSize: 18,
      marginRight: 5,
      color: "#ffffff",
      borderRadius: 2,
      padding: 2,
    },
    "&:hover": {
      backgroundColor: "#58DA7E",
    },
  },
  completeBtn: {
    background: "#679BFE",
    color: "#ffffff",
    borderRadius: 0,
    textTransform: "capitalize",
    padding: "2px 8px",
    cursor: "auto",
    "& svg": {
      verticalAlign: "middle",
      fontSize: 18,
      marginRight: 5,
      color: "#ffffff",
      borderRadius: 2,
      padding: 2,
    },
    "&:hover": {
      backgroundColor: "#679BFE",
    },
  },
  groupBtn: {
    background: "#FBA504",
    color: "#ffffff",
    borderRadius: 0,
    textTransform: "capitalize",
    padding: "2px 8px",
    textAlign: "left",
    "&:hover": {
      backgroundColor: "#FBA504",
    },
  },
  campIcon: {
    padding: "3px 5px",
    background: "#E5EEFF",
    borderRadius: 2,
    fontWeight: 500,
    fontSize: 12,
    color: "#0FE5000",
    marginRight: 10,
    "& svg": {
      verticalAlign: "middle",
      fontSize: 12,
      marginRight: 3,
    },
  },
  durationArea: {
    color: palette.primary.main,
    fontWeight: 500,
    fontSize: 14,
    "& svg": {
      fontSize: 18,
      marginRight: 5,
      verticalAlign: "text-top",
    },
  },
  greenLiftBox: {
    width: 135,
    height: 204,
    background: "#EAF6ED",
    textAlign: "center",
    padding: "40px 10px",
    float: "right",
    "& p:first-child": {
      fontSize: 18,
      letterSpacing: "-0.02em",
    },
    "& p:nth-child(2)": {
      color: "#24A148",
      margin: "15px 0",
      fontSize: 30,
      "& svg": {
        marginRight: 5,
        fontSize: 32,
        verticalAlign: "middle",
      },
    },
    "& p:last-child": {
      color: "#24A148",
      fontSize: 18,
    },
  },
  redLiftBox: {
    width: 135,
    height: 204,
    background: "#FBE8E9",
    textAlign: "center",
    padding: "40px 10px",
    float: "right",
    "& p:first-child": {
      fontSize: 18,
      letterSpacing: "-0.02em",
    },
    "& p:nth-child(2)": {
      color: "#E01F29",
      margin: "15px 0",
      fontSize: 30,
      "& svg": {
        marginRight: 5,
        fontSize: 32,
        verticalAlign: "middle",
      },
    },
    "& p:last-child": {
      color: "#E01F29",
      fontSize: 18,
    },
  },
  detailBlock: {
    width: "95%",
    margin: "0 auto",
  },
  merchArea: {
    cursor: "pointer",
    padding: "3px 5px",
    background: "#E5EEFF",
    fontWeight: 400,
    color: "#333333",
    "& svg": {
      verticalAlign: "middle",
      fontSize: 16,
    },
  },
  merchDialog: {
    "& svg": {
      margin: "0 20px",
    },
    "& h5": {
      marginBottom: 30,
      padding: 10,
    },
  },
  accordBlock: {
    background: "#ffffff",
    "& h4": { color: "#333333", marginBottom: 10 },
    "& h5": { color: "#333333" },
  },
  sideBlock: {
    "& h4": {
      color: "#333333",
      marginBottom: 10,
      position: "relative",
      textTransform: "capitalize",
      "& svg": {
        position: "absolute",
        right: 0,
        cursor: "pointer",
      },
      "& span": {
        "& svg": {
          position: "relative",
          verticalAlign: "sub",
          margin: "0 10px",
          color: "#182C52",
        },
      },
    },
    "& h5": { color: "#24A148", margin: "15px 0" },
    "& h6": {
      color: "#0FE500",
    },
  },
 
  cardBlockSvgRed: {
    "& svg": {
      color: "#ffffff",
      borderRadius: 2,
      padding: 2,
      fontSize: 30,
      background: "#E01F29",
    },
  },
  cardBlockSvgGreen: {
    "& svg": {
      color: "#ffffff",
      borderRadius: 2,
      padding: 2,
      fontSize: 30,
      background: "#24A148",
    },
  },
  cardBlockLiftRed: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: 5,
    background: "#FBE8E9",
    color: "#E01F29",
    "& span": {
      color: "#E01F29",
    },
  },
  cardBlockLiftGreen: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: 5,
    background: "#EAF6ED",
    color: "#24A148",
    "& span": {
      color: "#24A148",
    },
  },
  cardBlockVal: {
    padding: "12px 0 !important",
    "& h4": {
      display: "inline-block",
      lineHeight: 1.5,
    },
    "& span": {
      display: "inline-block",
      padding: "0 0 0 10px",
      fontWeight: 500,
    },
  },
  yellowLiftBox: {
    width: 135,
    height: 105,
    background: "#fffde7",
    textAlign: "center",
    padding: "10px 0",
    float: "right",
    "& p:first-child": {
      fontSize: 16,
      letterSpacing: "-0.02em",
    },
    "& p:nth-child(2)": {
      margin: "10px 0",
      fontSize: 22,
      "& svg": {
        marginRight: 5,
        fontSize: 25,
        verticalAlign: "middle",
      },
    },
    "& p:last-child": {
      color: "#ff6f00",
    },
  },
  outlierArea: {
    float: "right"
  },

  card: {
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    transition: "0.3s",
    padding: "18px",
    borderRadius: "6px",
  },
  cardText: {
    fontSize: "16px",
    fontWeight: 400,
    color: "#333333",
    letterSpacing: "-0.02em",
  },
  innerCard: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0px",
  },
  liftText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#333333",
    letterSpacing: "-0.02em",
  },
  absLiftText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#333333",
    letterSpacing: "-0.02em",
  },
  filterArea: {
    float: "left",
    width: "100%",
    background: "#F4F6F8",
    padding: 20,
    marginBottom: 0
  },
  prePostToggle: {
    fontSize: 20,
    color: "#333333",
    background: "#FFFFFF",
    borderRadius: 20,
    padding: "8px 25px"
  },
  applyBtn: {
    marginTop: 12,
    borderRadius: 0,
    textTransform: "capitalize",
  },
  //
  buttonFilter: {
    margin: 0,
    padding: 5,
    background: "#182C52",
    borderRadius: 4,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#182C52",
    },
    "& span": {
      "& span": {
        margin: 0,
      },
    },
  },
  filterAreaDropDown: {
    padding: "10px 16px",
    background: "#F4F6F8",
    margin: "3px 0 10px 0",
    "& $input": {
      padding: 10,
    },
    "& $label": {
      transform: "translate(14px, 10px) scale(1)",
    },
    "& $div.MuiSelect-outlined.MuiSelect-outlined": {
      padding: 10,
    },
  },
  resetBtn: {
    cursor: "pointer"
  },
  tableRightBorder: {
    position: "sticky",
    top: 0,
    backgroundColor: palette.tableColors.background,
    "& th": {
      border: "1px solid",
      borderColor: palette.tableColors.border,
      fontSize: 14,
      padding: "6px 16px",
      textAlign: "left",
      color: palette.tableColors.text,
      fontWeight: 400,
    },
  },

  statsigArea: {
    fontSize: 12,
    lineHeight: 1.2,
    padding: "5px 0",
    borderRadius: "4px",
    textAlign: "center",
    minWidth: "100px",
  },
  innerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  ///merch
  merchBtnGroup: {
    "& button.Mui-selected": {
      backgroundColor: "transparent",
    },
  },
  unselectedLevel: {
    border: 0,
    padding: 0,
    margin: "15px 15px 15px 0",
    background: "transparent",
    "& svg": {
      display: "none",
    },
    "& p": {
      background: "#FFFFFF",
      boxShadow: "0px 20px 48px -12px rgba(0, 0, 0, 0.2)",
      borderRadius: 2,
      padding: "10px 50px",
      color: "#8E44AD",
    },
  },
  selectedLevel: {
    border: 0,
    padding: 0,
    margin: "15px 15px 15px 0",
    background: "transparent",
    "& svg": {
      margin: "10px 15px 10px 10px",
      color: "#8E44AD",
      display: "block",
    },
    "& p": {
      background: "#8E44AD",
      boxShadow: "0px 20px 48px -12px rgba(0, 0, 0, 0.2)",
      borderRadius: 2,
      padding: "10px 50px",
      color: "#ffffff",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  info: {
    padding: "40px 0 !important",
    textAlign: "center",
    "& h3": {
      lineHeight: 10,
    },
  },
  formControl: {
    width: "100%",
  },
  divider: {
    margin: "15px 0"
  },
  trendIcon: {
    "& svg": {
      color: "#24A148 !important",
    },
    "& br + svg": {
      color: "#E01F29 !important",
    }
  },
  dividerPurchase: {
    margin: "31px 0"
  }
}));
